export enum BonusType {
  REFERRAL = "REFERRAL",
  SEASONAL = "SEASONAL",
  INCENTIVE = "INCENTIVE",
}

export const BonusTypeLabels: Record<BonusType, string> = {
  [BonusType.REFERRAL]: "Referral",
  [BonusType.SEASONAL]: "Seasonal",
  [BonusType.INCENTIVE]: "Incentive",
};

export interface BonusDTO {
  id: string;
  title: string;
  bonusType: BonusType;
  startDate: string;
  endDate: string;
  requiredParties?: number | null;
  dollarAmount?: number | null;
  topN?: number | null;
  notes?: string | null;
  archived: boolean;
  canDelete: boolean;
}

export interface ActiveBonusDTO {
  id: string;
  title: string;
  bonusType: BonusType;
  startDate: string;
  endDate: string;
  notes?: string | null;
  topN?: number | null;
  dollarAmount?: number | null;
  requiredParties?: number | null;
  userCompletedParties?: number | null;
  progressPercent?: number | null;
}

export interface EarnedBonusDTO {
  id: string;
  bonusId: string;
  bonusTitle: string;
  bonusType: BonusType;
  userId: string;
  userName: string;
  referredUserId?: string | null;
  referredUserName?: string | null;
  dollarAmount?: number | null;
  paid: boolean;
  paidDate?: string | null;
  paymentCheckId?: string | null;
  earnedDate: string;
}

export interface TopPerformerDTO {
  userId: string;
  userName: string;
  partiesWorked: number;
  rank: number;
  earnedBonusExists: boolean;
  paid: boolean;
  earnedBonusId?: string | null;
}
